// extracted by mini-css-extract-plugin
module.exports = {"ContactPage":"ContactPage_ContactPage__8a2Hp","Title":"ContactPage_Title__3j7Ep"};